import React from 'react';
import { BrowserRouter as Router, Route, NavLink } from "react-router-dom";
import data from './elem_roscados.json'

export class elem_roscados extends React.Component {

	componentDidMount () {
        const script = document.createElement("script");

        script.async = true;
        
		script.innerHTML = "$('.mat-input').focus(function(){$(this).parent().addClass('is-active is-completed');});$('.mat-input').focusout(function(){if($(this).val() === '')$(this).parent().removeClass('is-completed');$(this).parent().removeClass('is-active');})"; 

        document.body.appendChild(script);


    }


	render(){

		return (
				<div id="inicio">
					
					<section class="container-fluid section-nuestros-productos">
					<article class="row">
					
							{

								data.map(function(movie){



									const numbers = movie.materialesDisponibles;
									const listItems = numbers.map((number) =>
										<li>{number}</li>
									);

									

								return <div class="col-md-2 card-col-flex">

										<div class="card-lb">

											<ul>
												<li><img src={movie.imgProducto} alt="" title=""/></li>
												<li class="name-product">{movie.id}</li>
												<li class="detail-product">{movie.title}</li>
											</ul>
										   
										<button type="button" class="btn" data-toggle="modal" data-target={"#" + movie.modalTarget}>
										Ver detalle
										</button>

									   </div>

									   
										


										<div class="modal fade" id={movie.modalTarget} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
										<div class="modal-dialog" role="document">
										<div class="modal-content">
										<div class="modal-header">
										<h5 class="modal-title" id="exampleModalLabel">Detalle de producto</h5>
										<button type="button" class="close" data-dismiss="modal" aria-label="Close">
										<span aria-hidden="true">&times;</span>
										</button>
										</div>
										<div class="modal-body">
										<ul>
											<li><img src={movie.imgProductoG} alt="" title=""/></li>
											<li class="name-product-modal">{movie.id}</li>
										</ul>

											<table class="table ap-table">
												<thead>
											      <tr>
											        <th></th>
											        
											       </tr>
											    </thead>
											    <tbody>
		      										<tr>
		      											<td class="brand">
		      												<ul>
		      													{listItems}
		      												</ul>

	      												</td>
		      											
		  										    </tr>
		    									</tbody>
									   		</table>
										</div>
										<div class="modal-footer">
											<NavLink class="btn pedir-presupuesto" activeClassName={"active"} to="/contactos">Pedir presupuesto</NavLink>
										</div>
										</div>
										</div>
										</div>

									   </div>;
									   
								})
							}
						
					</article>
				</section>		


				</div>

				


				);
	}
} 


// WEBPACK FOOTER //
// ./src/components/elem_roscados.js